module.exports = __webpack_public_path__ + "static/media/doChakra_logo.af3b0833.webp";